import { Yup } from 'app/components/core/Form';

export const ViewIdSchema = Yup.string()
    .matches(/^_v\d+$/)
    .nullable(true);
